import { render, staticRenderFns } from "./FooterComponentSafeid.vue?vue&type=template&id=852cd19a&"
import script from "./FooterComponentSafeid.vue?vue&type=script&lang=js&"
export * from "./FooterComponentSafeid.vue?vue&type=script&lang=js&"
import style0 from "./FooterComponentSafeid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports